const INTERACTIVE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

export const isInteractiveTag = (tagName: string | undefined): boolean =>
  tagName !== undefined && INTERACTIVE_TAGS.has(tagName);

export const shouldIgnoreShortcut = (): boolean =>
  isInteractiveTag(document.activeElement?.tagName);
